import { Component, Host, h, Prop } from '@stencil/core';
import { Multilink } from '../types/link.types';
import { ButtonAppearance } from '../rcm-button/rcm-button.types';

@Component({
  tag: 'rcm-banner-basic',
  styleUrl: 'rcm-banner-basic.scss',
  shadow: true,
})
export class RcmBannerBasic {
  @Prop() headline: string;

  @Prop() subline: string;

  @Prop() linkText: string;

  @Prop() link: string;

  @Prop() secondaryButtonLabel: string;

  @Prop() secondaryButtonLink: string | Multilink;

  @Prop() secondaryButtonAppearance: ButtonAppearance;

  render() {
    return (
      <Host>
        <rcm-banner
          headline={this.headline}
          subline={this.subline}
          linkText={this.linkText}
          link={this.link}
          parentComponent="rcm-banner-basic"
          secondaryButtonLabel={this.secondaryButtonLabel}
          secondaryButtonLink={this.secondaryButtonLink}
          secondaryButtonAppearance={this.secondaryButtonAppearance}
        ></rcm-banner>
      </Host>
    );
  }
}
